import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import ListboxInput from "components/inputs/listbox"
import RentRollTable from "components/rent-roll/rent-roll/rent-roll-table"
import Modal from 'components/modal/basic-modal'
import RentRollReport from 'components/rent-roll/rent-roll/rent-roll-with-report'
import { WithTip } from 'components/tooltip/with-tip'
// Data
import api_match from "data/interface/api"
import automationService from "data/automation"
import areaMeasuresService, { Area } from 'data/area-measures'
import Client from "data/_client"
import importService from "data/import"
import calcService from 'data/calc'
import propertyService, { Property } from 'data/property'
import freeRentService, { FreeRent } from 'data/free-rent'
import recoveryGroupsService, { RecoveryGroup } from 'data/recovery-groups'
import recoveryPoolsService, { RecoveryPool } from 'data/recovery-pools'
import rentrollService, { RentRoll } from 'data/rent-roll'
import rentService, { Rent } from 'data/rent'
import reportTagService, { ReportTag } from 'data/report-tag'
import increaseService, { Increase } from 'data/increase'
import inflationService, { Inflation } from 'data/inflation'
import marketLeaseService, { MarketLease } from 'data/market-lease'
import namedRecoveryService, { Recovery } from 'data/named-recoveries'
import payoutService, { Payout } from 'data/payout'
import socketService, * as eventType from "data/socket"
import tenantcapitalService, { TenantCapital } from 'data/tenant-capital'
import { alphanum } from "components/table/lib/sort"
import { localizeNum } from "data/lib/numbers"
import { local, setlocal } from 'data/lib/local-json'
import { ContextRow } from './rent-roll-table'
import toggles from "feature-toggles"
import notificationService from "data/notification"
//Styles
import { AddIcon, ShowHideIcon } from "images/icons/tools"
import { QuickReportIcon } from "images/icons/header"
import { ContentSummary_s } from "styles/app-styles"
import { RentRoll_s } from "components/rent-roll/rent-roll/rent-roll-styles"
import propertyReportService from 'data/reports-property'

type SummaryType = {
  total: number
  calculated: string
  noneRenewalType: string
  calculatedLessNoneRenewalType: number
  variance: number
  futureAvailableDate: string,
  doesNotAffectOccupancy: string
}

const RentRollTab: FC<RouteComponentProps> = (props) => {
  const [data, setData]                       = useState<RentRoll[]>([])
  const [initSort, setInitSort]               = useState<boolean>(false)
  const [showImport, toggleShowImport]        = useState<boolean>(false)
  const [property, setProperty]               = useState<Property|null>(null);
  const [areaMeasures, setAreaMeasures]       = useState<Area[]>([])
  const [freeRent, setFreeRent]               = useState<FreeRent[]>([])
  const [rent, setRent]                       = useState<Rent[]>([])
  const [increase, setIncrease]               = useState<Increase[]>([])
  const [inflation, setInflation]             = useState<Inflation[]>([])
  const [marketLease, setMarketLease]         = useState<MarketLease[]>([])
  const [namedRecoveries, setNamedRecoveries] = useState<Recovery[]>([])
  const [payout, setPayout]                   = useState<Payout[]>([])
  const [recoveryGroups, setRecoveryGroups]   = useState<RecoveryGroup[]>([])
  const [recoveryPools, setRecoveryPools]     = useState<RecoveryPool[]>([])
  const [reportTags, setReportTags]           = useState<ReportTag[]>([])
  const [tenantCapital, setTenantCapital]     = useState<TenantCapital[]>([])
  const [summary, setSummary]                 = useState<SummaryType>()
  const [propertyId, setPropertyId]           = useState(propertyService.getStoredPropertyId())
  const [showColumnToggle, setShowColumnToggle] = useState<boolean>(false)
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);
  const [topHeight, setTopHeight] = useState(local('report-panel') || 100)
  const summaryBar = document.getElementById('summaryBar')
  const [summaryBarOpen, setSummaryBarOpen] = useState(_.get(summaryBar, "open") || false)
  const tableId = "rent-roll-table"
  const CLOSED_REPORT_WITH_PROPSUMMARY = 92.3

  let allCols = ['Status', 'Type', 'Start Date', 'End Date', 'Area', 'Rent', 'Free Rent', 'Recovery', 'Misc Revenue', 'T.I.', 'L.C.', 'Other Capital', 'Renewal Type', 'Market Lease', 'Available Date', 'Percentage Rent', 'Market Override', 'Notes']
  let initCols = ['Status', 'Type', 'Start Date', 'End Date', 'Area', 'Rent', 'Free Rent', 'Recovery', 'T.I.', 'L.C.', 'Renewal Type', 'Market Lease', 'Notes']
  let savedCols = local('rrColumns')
  const [columns, setColumns] = useState<string[]>(savedCols || initCols)

  useEffect(() => {
    calcService.fetchCalc(propertyId)
  })

  useEffect(() => {
    const importSubscription = importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const socketSubscription = socketService.stream().subscribe(data => {
      switch(data.eventType) {
        case eventType.RENTROLL_SUMMARY_COMPLETE:
          setSummary(_.get(data, 'event.msg.data.rentroll'))
          break;
      }
    })

    const areaMeasuresSubscription = areaMeasuresService.stream().subscribe(data => {
      api_match(
        data,
        init  => setAreaMeasures(init.value),
        ok    => {
          setAreaMeasures([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setAreaMeasures(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const increaseSubscription = increaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setIncrease(init.value),
        ok    => {
          setIncrease([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setIncrease(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          setInflation([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const marketLeaseSubscription = marketLeaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setMarketLease(init.value),
        ok    => {
          setMarketLease([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setMarketLease(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const freeRentSubscription = freeRentService.stream().subscribe(data => {
      api_match(
        data,
        init  => setFreeRent(init.value),
        ok    => {
          setFreeRent([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setFreeRent(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const namedRecoverySubscription = namedRecoveryService.stream().subscribe(data => {
      api_match(
        data,
        init  => setNamedRecoveries(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setNamedRecoveries([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setNamedRecoveries(ok.value)
          }
        },
        err   => {
          setNamedRecoveries(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const payoutSubscription = payoutService.stream().subscribe(data => {
      api_match(
        data,
        init  => setPayout(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setPayout([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setPayout(ok.value)
          }
        },
        err   => {
          setPayout(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const recoveryGroupsSubscription = recoveryGroupsService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRecoveryGroups(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setRecoveryGroups([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setRecoveryGroups(ok.value)
          }
        },
        err   => {
          setRecoveryGroups(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const recoveryPoolsSubscription = recoveryPoolsService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRecoveryPools(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setRecoveryPools([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setRecoveryPools(ok.value)
          }
        },
        err   => {
          setRecoveryPools(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const rentRollSubscription = rentrollService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const rentSubscription = rentService.stream().subscribe(data => {
      api_match(
        data,
        init  => setRent(init.value),
        ok    => {
          setRent([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setRent(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const reportTagSubscription = reportTagService.stream().subscribe(data => {
      api_match(
        data,
        init  => setReportTags(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setReportTags([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setReportTags(ok.value)
          }
        },
        err   => {
          setReportTags(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const tenantCapitalSubscription = tenantcapitalService.stream().subscribe(data => {
      api_match(
        data,
        init  => setTenantCapital(init.value),
        ok    => {
          setTenantCapital([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
        },
        err   => {
          setTenantCapital(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      areaMeasuresSubscription.unsubscribe()
      increaseSubscription.unsubscribe()
      inflationSubscription.unsubscribe()
      marketLeaseSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      freeRentSubscription.unsubscribe()
      namedRecoverySubscription.unsubscribe()
      payoutSubscription.unsubscribe()
      recoveryGroupsSubscription.unsubscribe()
      recoveryPoolsSubscription.unsubscribe()
      rentRollSubscription.unsubscribe()
      rentSubscription.unsubscribe()
      reportTagSubscription.unsubscribe()
      socketSubscription.unsubscribe()
      tenantCapitalSubscription.unsubscribe()
      importSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    const socketSubscription = socketService.stream().subscribe(socket => {
      switch(true) {
        case socket.eventType === eventType.RENTROLL_REORDER_COMPLETE:
          window.location.reload()
          break
      }
    })

    return function cleanup() {
      socketSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (_.isNil(propertyId)) return
    areaMeasuresService.fetchAreaMeasures(propertyId)
    increaseService.fetchIncrease(propertyId)
    inflationService.fetchInflation(propertyId)
    marketLeaseService.fetchMarketLeases(propertyId)
    propertyService.fetchProperty(propertyId)
    freeRentService.fetchFreeRent(propertyId)
    payoutService.fetchPayout(propertyId)
    namedRecoveryService.fetchNamedRecoveries(propertyId)
    recoveryGroupsService.fetchRecoveryGroups(propertyId)
    recoveryPoolsService.fetchRecoveryPools(propertyId)
    rentrollService.fetchRentRoll(propertyId)
    rentService.fetchRent(propertyId)
    reportTagService.fetchReportTags(propertyId)
    tenantcapitalService.fetchTenantcapital(propertyId, "all")

    Client.post('msg/svc_rentroll_summary', { propertyId, _synchronous: true })
    .then((d) => _.get(d, 'data.rentroll'))
    .then(setSummary)

  }, [propertyId])

  useEffect(() => {
    const automationSubscription = automationService.stream().subscribe(event => {
      switch(true) {
        case event.type === "SUMMARY_BAR_OPEN":
          if(event.data === true) {
            if(topHeight === 100) {
              setTopHeight(CLOSED_REPORT_WITH_PROPSUMMARY)
            }
          } else {
            if(topHeight === CLOSED_REPORT_WITH_PROPSUMMARY) {
              setTopHeight(100)
            }
          }
          setSummaryBarOpen(event.data)
          break
      }
    })

    return function cleanup() {
      automationSubscription.unsubscribe()
    }
  }, [topHeight])

  const handleMouseDown = (e) => {
    e.preventDefault()

    const startY = e.clientY
    const initialTopHeight = topHeight

    let animationFrameId

    const onMouseMove = (e) => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId)
      }

      animationFrameId = requestAnimationFrame(() => {
        const deltaY = e.clientY - startY
        const newTopHeight = initialTopHeight + (deltaY / (window.innerHeight - 212)) * 100
        const maxTopHeight = 100

        const clampedTopHeight = Math.max(20, Math.min(newTopHeight, maxTopHeight))
        setTopHeight(clampedTopHeight)
        setlocal('report-panel', clampedTopHeight)
      });
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove)
      document.removeEventListener("mouseup", onMouseUp)

      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId)
      }
    }

    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)
  }

  const toggleReportWindow = (e) => {
    let newTopHeight = 100
    if(topHeight === 100 || topHeight === CLOSED_REPORT_WITH_PROPSUMMARY) newTopHeight = 52
    if(newTopHeight === 100 && summaryBarOpen) newTopHeight = CLOSED_REPORT_WITH_PROPSUMMARY
    setTopHeight(newTopHeight)
    setlocal('report-panel', newTopHeight)
  }

  const Add = () => {
    return (
      <a onClick={() => rentrollService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const TenantCashFlowReportIcon = () => {
    return (
      <a onClick={() => propertyReportService.tenantCashFlowReport(data.map(rentroll => rentroll['rentrollid']))}>
        <Isvg src={QuickReportIcon} width="30px" />
      </a>
    )
  }

  const ShowHideColumns = () => {
    return (
      <a onClick={() => setShowColumnToggle(!showColumnToggle)}>
        <Isvg src={ShowHideIcon} />
      </a>
    )
  }

  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            if (_.some(selected, 'parentrentrollid')){
              notificationService.notify({
                type: "warn",
                message: "Option records can not be deleted via multiselect.",
                dismiss: 3000
              })
              return
            }
                  setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'rentrollid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected && selected.length ? selected : data

  let summaryText
  if (summary) {
    const f = (v) => localizeNum(v) || '-'
    const { total, calculated, noneRenewalType, calculatedLessNoneRenewalType, variance, futureAvailableDate, doesNotAffectOccupancy  } = summary
    summaryText = `*TotalArea: ${f(total)} | Input: ${f(calculated)} | Renewal Type - None: ${f(noneRenewalType)} | Input Less None: ${f(calculatedLessNoneRenewalType)} | Variance: ${f(variance)} | Future Available Date: ${f(futureAvailableDate)} | Does Not Affect Occupancy: ${f(doesNotAffectOccupancy)}`
  }

  const updateColumns = (val:string[]) => {
    setColumns(val);
    setlocal('rrColumns', val);
  }

  return (
    <RentRoll_s>
      <Toolbar>
        <WithTip position="bottom">
          <span>Add Row</span>
          <Add />
        </WithTip>
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
        <WithTip position="bottom">
          <span>Tenant Cash Flow Report</span>
          <TenantCashFlowReportIcon />
        </WithTip>
        <WithTip position="bottom">
          <span>Excel Import</span>
          <ImportIcon />
        </WithTip>
        <WithTip position="bottom">
          <span>Excel Export</span>
          <ExportIcon template="rentroll" />
        </WithTip>
        <WithTip position="bottom">
          <span>Show/Hide Columns</span>
          <ShowHideColumns />
        </WithTip>
      </Toolbar>
      { showImport && <Import /> }
      {toggles.displayRentRollReports() &&
        <div className="vertical-resizable-container">
          <div className="panel top-panel" style={{ height: `${topHeight}%` }}>
            { data && property && !showImport && areaMeasures && increase && inflation && marketLease && namedRecoveries && freeRent && payout && recoveryGroups && recoveryPools && reportTags && rent && tenantCapital &&
              <RentRollTable
                tableId={tableId}
                columns={columns}
                data={_data}
                areaMeasures={areaMeasures}
                increase={increase}
                inflation={inflation}
                property={property}
                marketLease={marketLease}
                namedRecoveries={namedRecoveries}
                freeRent={freeRent}
                payout={payout}
                recoveryGroups={recoveryGroups}
                recoveryPools={recoveryPools}
                rent={rent}
                reportTags={reportTags}
                tenantCapital={tenantCapital}
                selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}}
              />
            }
          </div>
          <div className="horizontal-divider" onMouseDown={handleMouseDown} onDoubleClick={toggleReportWindow}></div>
          <div className="panel bottom-panel" style={{ height: `${100 - topHeight}%` }}>
            <RentRollReport data={_data}/>
          </div>
        </div>
      }
      {!toggles.displayRentRollReports() && data && property && !showImport && areaMeasures && increase && inflation && marketLease && namedRecoveries && freeRent && payout && recoveryGroups && recoveryPools && reportTags && rent && tenantCapital &&
        <RentRollTable
          tableId={tableId}
          columns={columns}
          data={_data}
          areaMeasures={areaMeasures}
          increase={increase}
          inflation={inflation}
          property={property}
          marketLease={marketLease}
          namedRecoveries={namedRecoveries}
          freeRent={freeRent}
          payout={payout}
          recoveryGroups={recoveryGroups}
          recoveryPools={recoveryPools}
          rent={rent}
          reportTags={reportTags}
          tenantCapital={tenantCapital}
          selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}}
        />
      }
      { !showImport && <ContentSummary_s>{ summaryText }</ContentSummary_s> }
      { showColumnToggle && <Modal show={showColumnToggle} title="Show/Hide Columns" toggleShow={setShowColumnToggle} width={500}>
          <ListboxInput
            field="columns"
            value={columns}
            options={allCols.map(column => { return {'label': column, 'value': column}})}
            persist={(field:string, val:string[]) => updateColumns(val)}
            multiple={true}
          />
      </Modal>}
    </RentRoll_s>
  )
}

export default RentRollTab
